import {
  HOME_PAGE_URL,
  CONTACT_PAGE_URL,
  ABOUT_PAGE_URL,
  LINKS_PAGE_URL,
  DOMINATION_GALLERY_PAGE_URL,
  ABDL_GALLERY_PAGE_URL,
  HOW_TO_BOOK_PAGE_URL,
  DOMINATION_SERVICES_PAGE_URL,
  ABDL_SERVICES_PAGE_URL,
  DOM_FORM_PAGE_URL,
  ABDL_FORM_PAGE_URL,
  TOUR_PAGE_URL,
  REVIEWS_PAGE_URL,
  ADMIN_CONTACT_FORM_PAGE_URL,
} from '../Routes';

export const getNavLinkItemsArray = (user) => [
  { path: HOME_PAGE_URL, label: 'Home' },
  { path: ABOUT_PAGE_URL, label: 'About' },
  {
    label: 'Bookings',
    subpages: [
      { path: TOUR_PAGE_URL, label: 'Tour' },
      { path: HOW_TO_BOOK_PAGE_URL, label: 'How To Book' },
      { path: CONTACT_PAGE_URL, label: 'Contact Me' },
      { path: DOM_FORM_PAGE_URL, label: 'Dominatrix Form' },
      { path: ABDL_FORM_PAGE_URL, label: 'ABDL Form' },
    ],
  },
  {
    label: 'Galleries',
    subpages: [
      { path: DOMINATION_GALLERY_PAGE_URL, label: 'Domination Gallery' },
      { path: ABDL_GALLERY_PAGE_URL, label: 'ABDL Gallery' },
    ],
  },
  {
    label: 'Services',
    subpages: [
      { path: DOMINATION_SERVICES_PAGE_URL, label: 'Domination' },
      { path: ABDL_SERVICES_PAGE_URL, label: 'ABDL' },
    ],
  },
  { path: LINKS_PAGE_URL, label: 'Links' },
  { path: REVIEWS_PAGE_URL, label: 'Reviews' },
  ...(user?.email
    ? user.role === 'ADMIN' || user.role === 'DEVELOPER'
      ? [
          {
            label: 'Admin',
            path: ADMIN_CONTACT_FORM_PAGE_URL,
          },
        ]
      : []
    : []),
];
